// Detects common in-app browsers (WhatsApp, FB, Instagram, etc.) where
// Google OAuth and other webview-restricted flows silently fail.

export type DevicePlatform = "ios" | "android" | "other";

export interface InAppBrowserInfo {
  isInApp: boolean;
  app: string | null;
  platform: DevicePlatform;
}

function detectPlatform(agent: string): DevicePlatform {
  if (/iPhone|iPad|iPod/i.test(agent)) return "ios";
  if (/Android/i.test(agent)) return "android";
  return "other";
}

export function detectInAppBrowser(ua?: string): InAppBrowserInfo {
  const agent = (ua ?? (typeof navigator !== "undefined" ? navigator.userAgent : "")) || "";
  const platform = detectPlatform(agent);

  const match = (app: string): InAppBrowserInfo => ({ isInApp: true, app, platform });

  if (/WhatsApp/i.test(agent)) return match("WhatsApp");
  if (/Instagram/i.test(agent)) return match("Instagram");
  if (/FBAN|FBAV|FB_IAB|FB4A/i.test(agent)) return match("Facebook");
  if (/Messenger/i.test(agent)) return match("Messenger");
  if (/\bLine\//i.test(agent)) return match("Line");
  if (/musical_ly|Bytedance|TikTok/i.test(agent)) return match("TikTok");
  if (/Twitter|TwitterAndroid/i.test(agent)) return match("Twitter");
  // Generic Android WebView
  if (/Android.*;\s*wv\)/i.test(agent)) return match("in-app browser");

  return { isInApp: false, app: null, platform };
}

export function isInAppBrowser(): boolean {
  return detectInAppBrowser().isInApp;
}
